import { render, staticRenderFns } from "./TaskAddTaskDialog.vue?vue&type=template&id=465a8b3d&scoped=true&"
import script from "./TaskAddTaskDialog.vue?vue&type=script&lang=js&"
export * from "./TaskAddTaskDialog.vue?vue&type=script&lang=js&"
import style0 from "./TaskAddTaskDialog.vue?vue&type=style&index=0&id=465a8b3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465a8b3d",
  null
  
)

export default component.exports